import React from 'react';
import UnitLifeCycleListContainer from './containers/unit-life-cycle-list/unit-life-cycle-list.container';

export const UnitLifeCycleModule: React.FC = () => {
  return <UnitLifeCycleListContainer />;
};
